import { useEffect, useState } from "react";

import { generateUuid } from "shared/functions";
import { requestBackend } from "shared/request";

function useChatId(
  token: string,
  botId: string,
  configChatId: string | undefined,
  eventSource: EventSource | null,
  setChatData: React.Dispatch<React.SetStateAction<any[]>>,
) {
  const [chatId, setChatId] = useState(configChatId || generateUuid());

  useEffect(() => {
    setChatId(configChatId || generateUuid());
    if (!configChatId) {
      return;
    }
    requestBackend(
      `/v1/botsonic/${botId}/get-conversations-by-widget/${configChatId}/chats`,
      {
        headers: {
          token,
        },
      },
    );
    // .then(setChatData, err => console.error(err));
  }, [token, botId, configChatId, setChatData]);

  const resetChat = () => {
    setChatData([]);
    setChatId(generateUuid());
    eventSource?.close?.();
  };

  return {
    chatId,
    setChatId,
    resetChat,
  };
}

export default useChatId;
